import React from 'react';
import Button, { ButtonProps } from '.';
import { useNamespacedTranslation } from '../../hooks/useNamespacedTranslation';

type Props = ButtonProps;

//TODO: Make CancelButton refactoring and try use as much as possible
export const CancelButton: React.FC<Props> = ({
  label,
  variant,
  children,
  ...props
}) => {
  const t = useNamespacedTranslation('components.cancelButton');
  // `Button` renders both `label` and `children`; avoid duplicating the default
  // "Cancel" when callers pass the translated text as children (e.g. modals).
  const resolvedLabel = label ?? (children ? undefined : t('cancel'));
  return (
    <Button
      {...props}
      label={resolvedLabel}
      variant={variant ?? 'outline-secondary'}>
      {children}
    </Button>
  );
};
